import { Components } from 'lib/sequence/component/children/find'

/**
 * Returns `args`.
 *
 * Makes an action return the arguments expected by the action sequence.
 *
 * @param _     usually, the components find proxy
 * @param args  action arguments
 */
const finish = async (_: Components, ...args: any[]) => args

export default finish
